import { PropsOf } from '@emotion/react';
import { lazyDefault } from '../../../lib/lazyNamed';
import { colors } from '../../../style/theme';
import { asPopupButton } from './PopUpButton';

const SignUpPopupButton = asPopupButton(
  lazyDefault(() => import('../popups/SignUpPopup'))
);

export default function SignUpButton(props: PropsOf<typeof SignUpPopupButton>) {
  return (
    <SignUpPopupButton
      buttonType="filled"
      color={colors.successGreen}
      css={
        {
          fontWeight: 'normal',
          textAlign: 'left',
        } /* reset styles from DesktopNav */
      }
      padding="xTight"
      {...props}
    >
      Sign up
    </SignUpPopupButton>
  );
}
